import React, { useEffect, useState } from "react";
import { Application, ApplicationCustomers } from "@/api/applications";
import { Customer } from "@/api/customers";
import RigthPanel from "@/ui-controls/RigthPanel";
import NewAppCustomerForm from "@/components/customers/NewAppCustomerForm";

interface Props {
  application: Application | undefined;
  allCustomers: Customer[];
  nonAppCustomers: Customer[];
  isPanelOpenned: boolean;
  onSaveNewCustomer?: (customer: Customer) => any;
  onSave?: (appCustomers: ApplicationCustomers) => any;
  onPanelClosed?: () => any;
}

const NewAppCustomer = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onCloseNewAppCustomerPanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header="Add Application Customer"
        isOpen={isPanelOpen}
        dismissPanel={onCloseNewAppCustomerPanel}
        childComponent={NewAppCustomerForm}
        childProps={{
          application: props.application,
          allCustomers: props.allCustomers,
          nonAppCustomers: props.nonAppCustomers,
          onClose: () => onCloseNewAppCustomerPanel(),
          onAddNewCustomer: (newCustomer: Customer) => {
            if (props.onSaveNewCustomer) props.onSaveNewCustomer(newCustomer);
          },
          onSave: (appCustomers: ApplicationCustomers) => {
            if (props.onSave) props.onSave(appCustomers);
            onCloseNewAppCustomerPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default NewAppCustomer;
